<template>
  <div class="admin_nav">
    <ul>
      <li>
        <Link href="/users/analytics">ユーザー計測</Link>
      </li>
      <li>
        <Link href="/cohorts">コホート分析</Link>
      </li>
    </ul>
  </div>
</template>

<script>
  import {Link } from '@inertiajs/inertia-vue3';

  export default {
  components: {
    Link,
    // InertiaLink,
  },
};
</script>

<style scoped>
  .admin_nav ul {
    list-style-type: disc;
    display: flex;
  }
  .admin_nav ul li {
    margin-left: 40px;
  }
</style>